export const ROUTES = {
  home: '/',
  privacy: '/privacy',
  signinOidc: '/signin-oidc',
  logout: '/logout',
  afterLogout: '/afterlogout',
  cleanup: '/cleanup',
  economy: '/okonomi',
  housingAssociation: '/boligselskapet',
  boardwork: '/styrearbeid',
  communication: '/kommunikasjon',
  housingCooperative: '/boligbyggelaget',
  settings: '/innstillinger',
  sustainability: '/barekraft',
  auditor: '/revisor',
  janitor: '/vaktmester',
} as const
